import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { LoginServiceService } from "../Services/login-service.service";
import { CustomServiceService } from "../Services/custom-service.service";
@Injectable()
export class CheckUserLogin  {
    constructor(private router:Router,private loginServiceService:LoginServiceService, private customServices:CustomServiceService) {
 
    }
 
    canActivate(route: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): boolean|UrlTree {
        let url: string = state.url;

        if (this.customServices.GetLoggedInUser() == null) {
            this.loginServiceService.redirectUrl = state.url;
            this.router.navigate(["/login"]);

            //,{ queryParams: { retUrl: route.url} 
            return false;            
        } 
 
        return true;
    }
}
